import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../general/i18n/i18nProvider'
import {AuthInit} from './modules/auth'
import {LayoutProvider, LayoutSplashScreen} from '../general/layout/core'
import {MasterInit} from '../general/layout/core/MasterInit'
import {ThemeModeProvider} from '../general/partials'

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <ThemeModeProvider>
            <AuthInit>
              <Outlet />
              <MasterInit />
            </AuthInit>
          </ThemeModeProvider>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
